/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { t } from '../../locales/i18n';
import { deleteServiceAC } from '../../action-creators';

import { Icon } from 'semantic-ui-react';

import ServiceForm from '../forms/service-form';
import EditItemDialog from '../dialogs/edit-item-dialog';
import confirmDialog from '../confirm-dialog';
import styled from 'styled-components';
import { colors } from '../../themes';

import { CardAttr } from '../widgets/card-attr';

const Container = styled.div`
  padding: 1em;
`;
const Header = styled.section`
  display: grid;
  grid-template-columns: 1fr auto;
`;
const Actions = styled.div`
  i {
    cursor: pointer;
  }
  i.remove {
    color: ${colors.baseColors.red};
  }
`;
const Content = styled.section`
  display: grid;
  grid-gap: 4px;
`;

export default function ServiceCard(props: any) {
  return (
    <Container>
      <Header>
        <h3>Service: {props.name}</h3>
        <Actions>
          <EditItemDialog form={ServiceForm} {...props} />
          <Icon
            name="remove circle"
            onClick={() => confirmDialog(() => props.dispatch(deleteServiceAC(props._id)))}
            // color="red"
            size="large"
          />
        </Actions>
      </Header>
      <Content>
        <CardAttr title="Avg service time">{props.averageServiceTimeInMins} min</CardAttr>
      </Content>
    </Container>
  );
}
